import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { SubheaderTabChangeEventModel } from '../subheader-tabs/subheader-tabs.component';
import { BaseComponent } from '@macs-frontend/core';

@Component({
  selector: 'md-tabs-menu',
  templateUrl: 'tabs-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabsMenuComponent<T extends Record<string, string>>
  extends BaseComponent
  implements OnInit
{
  @Input() tabs?: T;
  @Input() defaultTab!: keyof T;

  public currentTab!: keyof T;

  get tabEntries(): Array<[keyof T, string]> {
    if (!this.tabs) {
      return [];
    }
    return Object.entries(this.tabs);
  }

  constructor(private cdr: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {
    this.currentTab = this.defaultTab;
  }

  onTabChange(event: SubheaderTabChangeEventModel) {
    this.currentTab = event.tab.id;
    this.cdr.markForCheck();
  }
}
